import { render, staticRenderFns } from "./editLimited.vue?vue&type=template&id=2284bc62&"
import script from "./editLimited.vue?vue&type=script&lang=js&"
export * from "./editLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports